import React from 'react';
import { ButtonLoading, ServiceSetComponent, SimpleDialog } from 'components';
import { Button, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { addOrRemoveServiceCallApi } from '../../../services/ServiceSetServices';
import useCustomHook from '../../../hooks';

const DialogServiceSet = ({
  openDialog,
  setOpenDialog,
  idServiceSet,
  serviceCall,
  confirmDialog,
}) => {
  const { handleSubmit, control, formState: { errors } } = useForm();
  const { loadingBtn, setLoadingBtn } = useCustomHook();

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onSubmit = async (data) => {
    setLoadingBtn(true);
    const dataApi = {
      webserviceId: serviceCall.value,
      serviceSetId: data.serviceSet.map((item) => item.id),
    };

    try {
      await addOrRemoveServiceCallApi([dataApi]);
      confirmDialog();
      handleCloseDialog();
    } catch (e) {}

    setLoadingBtn(false);
  };

  const ActionsBtn = () => {
    return (
      <Grid  direction="row" container  item xs={12} justifyContent='flex-end'>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="ثبت"
        />
        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </Grid>
    );
  };

  const paramsServiceSet = {
    pagination: { offset: 0, size: 15 },
  };

  return (
    <SimpleDialog
      fullWidth
      maxWidth="sm"
      open={openDialog}
      title={`انتساب مجموعه سرویس به سرویس "${serviceCall.label}"`}
      onClose={handleCloseDialog}
      formSubmit={handleSubmit(onSubmit)}
      actions={<ActionsBtn />}
    >
      <Grid container direction="row">
        <Grid item xs={12}>
          <Typography gutterBottom>هر وب سرویس حداقل باید عضو یک مجموعه سرویس باشد.</Typography>
        </Grid>
        <Grid item xs={12}>
          <ServiceSetComponent
            errors={errors}
            control={control}
            params={paramsServiceSet}
            exceptionId={idServiceSet}
          />
        </Grid>
      </Grid>
    </SimpleDialog>
  );
};

export default DialogServiceSet;
